import * as KosmosConfig from './kosmosConfig';
import * as AtlasConfig from './atlasConfig';

export const PROJECT = process.env.REACT_APP_PROJECT || 'atlas'; // or kosmos

export const AZURE_B2C_CONFIG = PROJECT === 'atlas' ? AtlasConfig.AZURE_B2C_CONFIG : KosmosConfig.AZURE_B2C_CONFIG;
export const WEBSOCKET_URL = PROJECT === 'atlas' ? AtlasConfig.WEBSOCKET_URL : KosmosConfig.WEBSOCKET_URL;
export const API_URL = PROJECT === 'atlas' ? AtlasConfig.API_URL : KosmosConfig.API_URL;

export const US_STATES = [
  { alias: 'AL', label: 'ALABAMA' },
  { alias: 'AK', label: 'ALASKA' },
  { alias: 'AS', label: 'AMERICAN SAMOA' },
  { alias: 'AZ', label: 'ARIZONA' },
  { alias: 'AR', label: 'ARKANSAS' },
  { alias: 'CA', label: 'CALIFORNIA' },
  { alias: 'CO', label: 'COLORADO' },
  { alias: 'CT', label: 'CONNECTICUT' },
  { alias: 'DE', label: 'DELAWARE' },
  { alias: 'DC', label: 'DISTRICT OF COLUMBIA' },
  { alias: 'FL', label: 'FLORIDA' },
  { alias: 'GA', label: 'GEORGIA' },
  { alias: 'GU', label: 'GUAM' },
  { alias: 'HI', label: 'HAWAII' },
  { alias: 'ID', label: 'IDAHO' },
  { alias: 'IL', label: 'ILLINOIS' },
  { alias: 'IN', label: 'INDIANA' },
  { alias: 'IA', label: 'IOWA' },
  { alias: 'KS', label: 'KANSAS' },
  { alias: 'KY', label: 'KENTUCKY' },
  { alias: 'LA', label: 'LOUISIANA' },
  { alias: 'ME', label: 'MAINE' },
  { alias: 'MD', label: 'MARYLAND' },
  { alias: 'MA', label: 'MASSACHUSETTS' },
  { alias: 'MI', label: 'MICHIGAN' },
  { alias: 'MN', label: 'MINNESOTA' },
  { alias: 'MS', label: 'MISSISSIPPI' },
  { alias: 'MO', label: 'MISSOURI' },
  { alias: 'MT', label: 'MONTANA' },
  { alias: 'NE', label: 'NEBRASKA' },
  { alias: 'NV', label: 'NEVADA' },
  { alias: 'NH', label: 'NEW HAMPSHIRE' },
  { alias: 'NJ', label: 'NEW JERSEY' },
  { alias: 'NM', label: 'NEW MEXICO' },
  { alias: 'NY', label: 'NEW YORK' },
  { alias: 'NC', label: 'NORTH CAROLINA' },
  { alias: 'ND', label: 'NORTH DAKOTA' },
  { alias: 'MP', label: 'NORTHERN MARIANA IS' },
  { alias: 'OH', label: 'OHIO' },
  { alias: 'OK', label: 'OKLAHOMA' },
  { alias: 'OR', label: 'OREGON' },
  { alias: 'PA', label: 'PENNSYLVANIA' },
  { alias: 'PR', label: 'PUERTO RICO' },
  { alias: 'RI', label: 'RHODE ISLAND' },
  { alias: 'SC', label: 'SOUTH CAROLINA' },
  { alias: 'SD', label: 'SOUTH DAKOTA' },
  { alias: 'TN', label: 'TENNESSEE' },
  { alias: 'TX', label: 'TEXAS' },
  { alias: 'UT', label: 'UTAH' },
  { alias: 'VT', label: 'VERMONT' },
  { alias: 'VA', label: 'VIRGINIA' },
  { alias: 'VI', label: 'VIRGIN ISLANDS' },
  { alias: 'WA', label: 'WASHINGTON' },
  { alias: 'WV', label: 'WEST VIRGINIA' },
  { alias: 'WI', label: 'WISCONSIN' },
  { alias: 'WY', label: 'WYOMING' },
];
